import { createFileRoute } from '@tanstack/react-router'
import { ErrorBoundary } from '@toss/error-boundary'
import { Suspense } from 'react'

import { PasswordResetErrorBoundaryFallback } from '@/pages/reset-password/error-boundary-fallback'
import { ResetPasswordPage } from '@/pages/reset-password/page'

import { HTTP_STATUS_MAP } from '@/lib/constants/http'
import { isWretchError } from '@/lib/types/predicate'

export const Route = createFileRoute('/reset-password')({
  validateSearch: (search: Record<string, unknown>): { t?: string } => {
    return {
      t: search.t as string,
    }
  },
  component: () => (
    <ErrorBoundary
      renderFallback={({ error }) => {
        if (isWretchError(error) && error.status === HTTP_STATUS_MAP.NOT_AUTHORIZED) {
          return <PasswordResetErrorBoundaryFallback message="The link to set your password has expired." />
        }

        return <PasswordResetErrorBoundaryFallback message="Something wrong happened. Please try again later." />
      }}
    >
      <Suspense fallback={null}>
        <ResetPasswordPage />
      </Suspense>
    </ErrorBoundary>
  ),
})
